import styled, { css } from 'styled-components';
import { rem } from 'polished';
import { fontSize } from '../../../mixins';
var StyledParagragh = styled.p.withConfig({
  displayName: "Paragraphstyle__StyledParagragh",
  componentId: "sc-1nu92po-0"
})(["margin:0;font-family:", ";outline:transparent;", ";", ";", ";", ";", ";", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.font.family.primary;
}, function (_ref2) {
  var theme = _ref2.theme;
  return fontSize(theme.font.size.xs);
}, color, regular, semibold, bold, overline);

function color(_ref3) {
  var theme = _ref3.theme,
      isOnDarkBg = _ref3.isOnDarkBg;
  var fontColor = isOnDarkBg ? theme.color.white : theme.color.black;
  return css(["color:", ";"], fontColor);
}

function regular(_ref4) {
  var variant = _ref4.variant,
      theme = _ref4.theme;
  return variant === 'regular' && css(["font-weight:", ";"], theme.font.weight.regular);
}

function semibold(_ref5) {
  var variant = _ref5.variant,
      theme = _ref5.theme;
  return variant === 'semibold' && css(["font-weight:", ";"], theme.font.weight.semibold);
}

function bold(_ref6) {
  var variant = _ref6.variant,
      theme = _ref6.theme;
  return variant === 'bold' && css(["font-weight:", ";"], theme.font.weight.bold);
}

function overline(_ref7) {
  var variant = _ref7.variant,
      isOnDarkBg = _ref7.isOnDarkBg,
      theme = _ref7.theme;
  // overline has a different color and doesn't use black
  var fontColor = isOnDarkBg ? theme.color.grey70 : theme.color.slate;
  return variant === 'overline' && css(["color:", ";font-weight:", ";letter-spacing:", ";text-transform:uppercase;"], fontColor, theme.font.weight.bold, rem('2px'));
}

export default StyledParagragh;